function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8242 10.7295H12.1721V12.8822H10.8242V10.7295Z",
  fill: "#A4B1BC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8358 16.1112L20.8932 12.0343C21.013 11.914 21.1452 11.8106 21.2869 11.7254L21.2598 11.6983C20.9506 11.389 20.5386 11.2188 20.0997 11.2188C20.0993 11.2188 20.0988 11.2188 20.0984 11.2188C19.6599 11.2191 19.2486 11.3895 18.9404 11.6986L16.4165 14.2298H2.91723C1.9882 14.2298 1.23242 14.9856 1.23242 15.9146C1.23242 15.9812 1.23673 16.0467 1.24428 16.1112H16.8358Z",
  fill: "#A4B1BC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.8015 12.9829C22.5377 12.7203 22.111 12.7213 21.8484 12.9852L17.3958 17.4591H0.673923C0.301738 17.4591 0 17.7609 0 18.133C0 18.5052 0.301738 18.807 0.673923 18.807H1.07504V20.1998C1.07504 20.572 1.37678 20.8737 1.74896 20.8737C2.12115 20.8737 2.42289 20.572 2.42289 20.1998V18.807H10.8245V20.0299C10.8245 20.4021 11.1262 20.7038 11.4984 20.7038C11.8706 20.7038 12.1723 20.4021 12.1723 20.0299V18.807H17.0246V20.0201C17.0246 20.3923 17.3263 20.694 17.6985 20.694C18.0707 20.694 18.3724 20.3923 18.3724 20.0201V18.3886L22.8038 13.9359C23.0663 13.6721 23.0653 13.2454 22.8015 12.9829Z",
  fill: "#A4B1BC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.10361 9.38163H7.69728C7.833 7.4038 8.16457 5.58735 8.65811 4.15814C9.32332 2.23184 10.1265 1.43783 10.8245 1.15739C11.0296 1.07499 11.2493 1.02876 11.4705 1.02521C11.6942 1.02157 11.9174 1.06187 12.1269 1.14004C12.1419 1.14566 12.1568 1.15146 12.1716 1.15739C12.8696 1.43783 13.6728 2.2318 14.338 4.15819C14.8316 5.5874 15.1632 7.4038 15.2989 9.38167H18.8925C19.0774 9.38167 19.2542 9.30574 19.3814 9.17154C19.5087 9.03743 19.5753 8.85687 19.5656 8.67226C19.3514 4.61052 16.1605 1.38306 12.172 1.05351V0.800388C12.172 0.428203 11.8703 0.126465 11.4981 0.126465C11.1259 0.126465 10.8241 0.428203 10.8241 0.800388V1.05351C6.8356 1.38306 3.6448 4.61052 3.43063 8.67226C3.42088 8.85687 3.48746 9.03743 3.6147 9.17154C3.74193 9.3057 3.91873 9.38163 4.10361 9.38163Z",
  fill: "#A4B1BC"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0648 4.59829C12.4976 2.95581 11.8667 2.37305 11.4989 2.37305C11.131 2.37305 10.5001 2.95586 9.93293 4.59829C9.48423 5.89762 9.17957 7.55879 9.04883 9.38184H13.9489C13.8182 7.55875 13.5136 5.89766 13.0648 4.59829Z",
  fill: "#A4B1BC"
});

var SvgVacationicon = function SvgVacationicon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVacationicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vacation.icon.9babacd9.svg";
export { ForwardRef as ReactComponent };